/* 孫吳傳・第 10 章：沔口（江夏，208 年）
 * 漢水由西往東注入長江。黃祖把兩艘蒙衝橫在江口，用棕櫚大纜繫著石碇；北岸是黃祖的營與江夏城。
 * 吳軍的船隊在西邊江面上；北岸只有營前的碼頭能靠岸。 */
export const BLOCK_X = 4300, ROPES = [[4300, 2150], [4300, 2900]], DOCK = [6100, 1850], ZU = [6500, 1050], EXIT = [7700, 500];
export default {
  id: 'mianku', name: '沔口', W: 8200, H: 5000, seed: 208,
  bases: [[700, 4300], [6500, 1100]],
  rivers: [{ pts: [[-100, 2550], [2500, 2450], [5000, 2560], [8300, 2480]], hw: 650, fords: [] }],
  roads: [
    { pts: [[6100, 1650], [6300, 1300], [6500, 1100], [7200, 800], [7700, 500]], w: 130 }, // 北岸：碼頭 → 黃祖營 → 東北的出口
    { pts: [[700, 4300], [1500, 3900], [2600, 3700]], w: 110 }, // 南岸
  ],
  rocks: [[2000, 1100, 420, 200], [4500, 900, 380, 180], [3500, 4200, 420, 200], [6800, 4000, 400, 200]],
  woods: 0.45,
  sight: 0.8,
  clearings: [[ZU[0], ZU[1], 560], [DOCK[0], DOCK[1] - 200, 260]],
  marsh: [[DOCK[0], DOCK[1] + 60, 220, 120]],
  tents: [{ x: ZU[0], y: ZU[1], n: 10, r: 520, chief: true, col: '#3e5a5a', flag: '黃' }, { x: 700, y: 4300, n: 4, r: 300, col: '#b8433a', flag: '孫' }],
  grass: [[5400, 1300, 240, 110], [7000, 1500, 220, 100]],
};
